import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export function TeamsPendingCard({ compact }) {
  return (
    <div className={`border-2 border-dashed border-[#f4b847] bg-[#FEF3D0] ${compact ? "p-5" : "p-8"}`} data-testid="teams-pending-release">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 bg-[#0F1F2E] text-[#F4B847] flex items-center justify-center shrink-0"><Lock size={18} /></div>
        <div>
          <div className="label-eyebrow text-[#7A5B17]">Coming at Session 1</div>
          <div className={`font-display font-black tracking-tighter text-[#7A5B17] mt-1 ${compact ? "text-xl" : "text-2xl sm:text-3xl"}`}>
            Your team will be announced at Session 1.
          </div>
          {!compact && (
            <p className="text-sm text-[#7A5B17] mt-2 max-w-xl">
              Teams are being finalised. Once the programme team releases them, your team, teammates and workspace appear here instantly — no need to do anything.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default function TeamReleaseGate({ children }) {
  const { user } = useAuth();
  const [released, setReleased] = useState(null);
  const isStudent = user?.role === "student";

  useEffect(() => {
    if (!isStudent) { setReleased(true); return; }
    api.get("/programme").then(({ data }) => setReleased(!!data?.teams_released)).catch(() => setReleased(true));
  }, [isStudent]);

  if (released === null) return null;
  if (!released) {
    return (
      <div className="space-y-6" data-testid="team-release-gate">
        <TeamsPendingCard />
      </div>
    );
  }
  return children;
}
